import { Phone, MapPin } from 'lucide-react';
import { ADRESSE_COURTE } from '../data/entreprise';

const FACEBOOK_URL = 'https://www.facebook.com/GrammeDemenagements';

export default function TopBar() {
  return (
    <div className="bg-[#F0B800] h-8 flex items-center justify-between px-4 md:px-8 text-[#0D1020] text-[13px] font-sans">
      {/* L'icône entre dans le lien : elle devient tapable, et le lien
          occupe toute la hauteur du bandeau. Une cible de 48 px demanderait
          d'épaissir le bandeau, ce qui est une décision graphique. */}
      <a
        href="tel:+3242645016"
        className="inline-flex items-center gap-1 h-8 px-1 -mx-1 hover:underline font-medium"
      >
        <Phone className="w-3.5 h-3.5" />
        04 264 50 16
      </a>
      <div className="flex items-center gap-1">
        <div className="hidden md:flex items-center gap-1">
          <MapPin className="w-3.5 h-3.5" />
          <span>{ADRESSE_COURTE}</span>
          <span className="mx-2">|</span>
        </div>
        <a
          href={FACEBOOK_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
          className="inline-flex items-center justify-center h-8 w-8 -mr-2"
        >
          <svg className="w-4 h-4 text-[#0D1020]" fill="currentColor" viewBox="0 0 24 24">
            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
          </svg>
        </a>
      </div>
    </div>
  );
}
